export function StarDisplay({ value = 0, count = null, size = "md" }) {
  const rounded = Math.round(Number(value || 0));
  const classes = size === "lg" ? "text-2xl" : "text-base";
  return (
    <span className="inline-flex items-center gap-2" aria-label={`${Number(value || 0).toFixed(1)} out of 5 stars`}>
      <span className={`${classes} tracking-tight text-amber-500`} aria-hidden="true">
        {Array.from({ length: 5 }, (_, i) => (i < rounded ? "★" : "☆")).join("")}
      </span>
      <span className="font-black text-neutral-950">{Number(value || 0).toFixed(1)}</span>
      {count !== null && <span className="text-sm font-semibold text-neutral-500">({count} {count === 1 ? "review" : "reviews"})</span>}
    </span>
  );
}

export function StarInput({ value, onChange, label = "Overall rating" }) {
  return (
    <fieldset>
      <legend className="text-sm font-black text-neutral-900">{label}</legend>
      <div className="mt-2 flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <button key={star} type="button" onClick={() => onChange(star)} className="focus-ring h-11 w-11 rounded-xl text-3xl text-amber-500 hover:bg-amber-50" aria-label={`${star} star${star > 1 ? "s" : ""}`} aria-pressed={value === star}>
            {star <= value ? "★" : "☆"}
          </button>
        ))}
      </div>
    </fieldset>
  );
}
